import {Injectable} from "@angular/core";
import {MobileAppService} from "./mobile-app.service";
import {AccountService} from "./account.service";
import {ActivatedRoute} from "@angular/router";
import {HttpParams} from "@angular/common/http";
import {ConfigService} from "./config.service";
import {DateTime} from "luxon";

@Injectable()
export class WindowService {
    constructor(private mobileAppService: MobileAppService, private accountService: AccountService, private activatedRoute: ActivatedRoute,
                private configService: ConfigService) {
    }

    openSelf(url: string, addAuthTokens: boolean = false)
    {
        if (addAuthTokens) url = this.urlWithAuthTokens(url);

        window.location.href = url;
    }

    open(url: string, addAuthTokens: boolean = false, forceNewWindow?: boolean) : Window | null {
        if (addAuthTokens) url = this.urlWithAuthTokens(url);

        if(forceNewWindow || !this.mobileAppService.isMobileApp()){
            return window.open(url);
        } else {
            window.location.href = url;
        }
    }

    urlWithAuthTokens(url: string) {
        let urlObj;
        try {
            urlObj = new URL(url);
        } catch {
            urlObj = new URL(url, this.configService.webUrl);
        }
        let newParams = new HttpParams();

        if (this.accountService.isLoggedIn()) {
            newParams = newParams.append('bearerToken', this.accountService.accessToken.bearerToken);
            newParams = newParams.append('refreshToken', this.accountService.accessToken.refreshToken);
            newParams = newParams.append('email', this.accountService.accessToken.email);
        }
        let passedParamLen = urlObj.searchParams == null ? 0 : urlObj.searchParams.size;
        if (newParams.keys().length) {
            url = `${urlObj.toString()}${passedParamLen > 0 ? '&' : '?'}${newParams.toString()}`;
        }
        else {
            url = urlObj.toString();
        }

        return url;
    }

    hardReloadCurrentPage() {
        window.location.reload();
    }

    downloadAsCsv(response: Blob, fileName: string) {
        // Create a blob object for the CSV data
        const blob = new Blob([response], { type: 'text/csv' });

        // Create a download link for the blob and trigger the download
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName

        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
    }
}
